<template>
  <!-- ページ内容 -->
  <div class="l-page l-page--onboarding">
    <main class="l-main">
      <div class="l-main-head">
        <div class="p-onboarding-progress">
          <div class="p-onboarding-progress__title">
            <div class="c-text">STEP.1</div>
          </div>
          <div class="p-onboarding-progress__content">
            <h1 class="c-title">
              <div class="c-title__text u-fs40">導入準備</div>
            </h1>
            <div class="c-progress">
              <ul class="c-progress-list">
                <li class="c-progress-list__item is-current">導入準備</li>
                <li class="c-progress-list__item">プロジェクト作成</li>
                <!-- <li class="c-progress-list__item">テスト配信</li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="l-main-content">
        <div class="p-onboarding__outline">
          <div class="c-text">
            導入準備として、メッセージ配信時に経由するGoogle社のFirebaseから必要な情報を取得します。<br />
            情報取得にはGoogleのアカウントが必要になります。<br />
            Googleアカウントであれば特に制限は御座いませんのでご準備ください。<br />
          </div>
        </div>
        <div class="p-onboarding-firebase">
          <h2 class="c-title">
            <div class="c-title__text u-fs34">Firebaseでのご準備の方法</div>
            <div class="c-text">※ Firebaseサイトのスクリーンショットは2021年10月時点の内容になりますので、変更されている可能性が御座います。</div>
          </h2>
          <ul class="p-onboarding-firebase-list">
            <li class="p-onboarding-firebase-list__item">
              <div class="p-onboarding-firebase__content">
                <h3 class="p-onboarding-firebase__title" data-number="1">Firebaseへアクセス</h3>
                <div class="c-text">
                  <a href="https://firebase.google.com/" target="_blank" rel="noopener noreferrer">https://firebase.google.com/</a>にアクセスしてGoogleアカウントでログインします。※Googleアカウントは御社でお使いのGoogleアカウントをご用意ください。ログイン後に[<strong>コンソールへ移動</strong>]をクリックしてください。
                </div>

                <button
                  class="c-btn c-btn--blue c-btn--firebase u-w100p u-h54 u-fs14"
                  type="button"
                  name="next"
                  value="next"
                  @click="onFirebaseClick($event)"
                >
                  <div class="c-btn__firebase-logo u-w130">
                    <img class="" src="/assets/img/logo-firebase--built-knockout.svg" />
                  </div>
                  <p class="c-btn__text">Google Firebaseサイトはこちら</p>
                </button>
              </div>
              <div class="c-image"><img src="/assets/img/capture-onboarding-01.png" /></div>
            </li>

            <li class="p-onboarding-firebase-list__item p-onboarding-firebase-list__item--group">
              <div class="p-onboarding-firebase__content">
                <h3 class="p-onboarding-firebase__title" data-number="2">プロジェクトを作成</h3>
                <div class="c-text">Firebaseコンソールで [<strong>新規プロジェクトを作成</strong>] をクリックし新しいプロジェクト名を入力します。</div>
              </div>
              <div class="c-image"><img src="/assets/img/capture-onboarding-02.png" /></div>
            </li>
            <li class="p-onboarding-firebase-list__item">
              <div class="p-onboarding-firebase__content">
                <div class="c-text">
                  Firebaseコンソールで残りの設定手順を実施した後、[<strong>プロジェクトを作成</strong>]（既存の Googleプロジェクトを使用する場合は[<strong>Firebaseを追加</strong>]）をクリックします。<br /><br />
                  Firebaseプロジェクトのリソースが自動的にプロビジョニングされます。処理が完了すると、FirebaseコンソールにFirebaseプロジェクトの概要ページが表示されます。<br /><br />
                  <strong>※プロジェクト作成中にGoogleアナリティクス（<strong>Firebaseプロジェクト向け</strong>）の設定がありますが、有効にせずお進みください</strong>
                </div>
              </div>
              <div class="c-image"><img src="/assets/img/capture-onboarding-03.png" /></div>
            </li>
            <li class="p-onboarding-firebase-list__item p-onboarding-firebase-list__item--group">
              <div class="p-onboarding-firebase__content">
                <h3 class="p-onboarding-firebase__title" data-number="3">プロジェクトの設定</h3>
                <div class="c-text">プロジェクト名の右側の設定ボタン<img class="setting-icon" src="/assets/img/capture-onboarding-firebase-setting-icon.png" />をクリックし、[<strong>プロジェクトの設定</strong>]を選択してください。</div>
              </div>
              <div class="c-image"><img src="/assets/img/capture-onboarding-firebase-01.png" /></div>
            </li>
            <li class="p-onboarding-firebase-list__item p-onboarding-firebase-list__item--group">
              <div class="p-onboarding-firebase__content">
                <div class="c-text">
                  全般タブにある<strong>マイアプリ</strong>の[<strong>&lt;/&gt;</strong>]ボタンをクリックします。<br /><br />
                  <strong>※ 既にアプリが存在する場合は、手順4. FirebaseSDK情報の取得へお進みください。</strong>
                </div>
              </div>
              <div class="c-image">
                <div class="c-image"><img src="/assets/img/capture-onboarding-firebase-02.png" /></div>
              </div>
            </li>
            <li class="p-onboarding-firebase-list__item p-onboarding-firebase-list__item--group">
              <div class="p-onboarding-firebase__content">
                <div class="c-text">
                  <strong>アプリのニックネーム</strong>を入力（プロジェクト名などご自由に設定下さい）し、[<strong>アプリを登録</strong>]をクリックします。<br /><br />
                  <strong>
                    ※ このアプリのFirebase Hostingも設定します。はチェックしないで下さい。
                  </strong>
                </div>
              </div>
              <div class="c-image">
                <div class="c-image"><img src="/assets/img/capture-onboarding-firebase-03.png" /></div>
              </div>
            </li>
            <li class="p-onboarding-firebase-list__item p-onboarding-firebase-list__item--group">
              <div class="p-onboarding-firebase__content">
                <div class="c-text">
                  下記のようなFirebase SDK設定情報が表示されたら、[<strong>コンソールに進む</strong>]をクリックします。
                </div>
              </div>
              <div class="c-image">
                <div class="c-image"><img src="/assets/img/capture-onboarding-firebase-04.png" /></div>
              </div>
            </li>
            <li class="p-onboarding-firebase-list__item">
              <div class="p-onboarding-firebase__content">
                <h3 class="p-onboarding-firebase__title" data-number="4">FirebaseSDK情報の確認</h3>
                <div class="c-text">
                  <strong>全般</strong>タブにある<strong>マイアプリ</strong>で追加されたアプリの<strong>SDKの設定と構成</strong>が表示されますので、[<strong>構成</strong>]を選択して表示された情報をコピーしてください。<br /><br />
                  <strong>※ 後程、本情報は必要となります。</strong>
                </div>
              </div>
              <div class="c-image">
                <div class="c-image"><img src="/assets/img/capture-onboarding-firebase-05.png" /></div>
              </div>
            </li>
            <li class="p-onboarding-firebase-list__item">
              <div class="p-onboarding-firebase__content">
                <h3 class="p-onboarding-firebase__title" data-number="5">Cloud Messaging API<br />（V1）の確認</h3>
                <div class="c-text">
                  Cloud Messaging API（V1）が有効であることを確認して次に進みます。<br />
                  無効の場合、右側の３点リーダーをクリック。<br /><br />
                  管理ページのリンクをクリックして、別タブで開いたGoogleCloudコンソールページで[<strong>有効にする</strong>]をクリックします。
                </div>
              </div>
              <div class="c-image">
                <img src="/assets/img/capture-onboarding-firebase-10.png" />
                <img src="/assets/img/capture-onboarding-firebase-11.png" />
              </div>
            </li>
            <li class="p-onboarding-firebase-list__item">
              <div class="p-onboarding-firebase__content">
                <h3 class="p-onboarding-firebase__title" data-number="6">Generate key pairの取得</h3>
                <div class="c-text">
                  [<strong>クラウドメッセージング</strong>]を選択し、ウェブ設定のウェブプッシュ証明書にある[<strong>Generate key pair</strong>]をクリックします。<br />
                </div>
              </div>
              <div class="c-image">
                <img src="/assets/img/capture-onboarding-firebase-06.png" />
                <img src="/assets/img/capture-onboarding-firebase-07.png" />
              </div>
            </li>
            <li class="p-onboarding-firebase-list__item">
              <div class="p-onboarding-firebase__content">
                <h3 class="p-onboarding-firebase__title" data-number="7">サービスアカウント情報確認</h3>
                <div class="c-text">
                  [<strong>サービスアカウント</strong>]を選択し、[<strong>新しい秘密鍵を生成</strong>]をクリックします。<br />
                  表示されたポップアップの[<strong>キーを生成</strong>]をクリックして、ファイルをダウンロードします。<br />
                </div>
              </div>
              <div class="c-image">
                <img src="/assets/img/capture-onboarding-firebase-08.png" />
                <img src="/assets/img/capture-onboarding-firebase-12.png" />
              </div>
            </li>

            <li class="p-onboarding-firebase-list__item">
              <div class="p-onboarding-firebase__content">
                <h3 class="p-onboarding-firebase__title" data-number="8">Firebese情報の確認</h3>
                <div class="c-text">
                  ⑦にてサービスアカウントキーのファイルダウンロード後、「<strong>API有効</strong>」「<strong>送信者ID</strong>」「<strong>ウェブプッシュ証明書（鍵ペア）</strong>」が表示されていればこれでFirebaseでの事前準備は完了です。
                </div>
              </div>
              <div class="c-image">
                <img src="/assets/img/capture-onboarding-firebase-13.png" />
              </div>
            </li>

          </ul>

          <button
            class="c-btn c-btn--blue u-w360 u-h48 u-fs18"
            type="button"
            name="next"
            value="next"
            @click="onNextClick($event)"
          >
            <p class="c-btn__text">プロジェクトの作成に進む</p>
          </button>


        </div>
      </div>
    </main>
  </div>
<!-- /ページ内容 -->
</template>

<script>
export default {
  props: {
    linkUrl: String,
  },
  methods: {
    onFirebaseClick: function (_event) {
      window.open("https://firebase.google.com/", "_blank", "noreferrer");
    },
    onNextClick: function (_event) {
      location.href = this.linkUrl;
    },
  },
}
</script>
